import type { Apollo } from 'src/gql/generated';
import type { AccountSubset, UserDefinedRoleSubset } from 'src/types/apollo/accounts';

export interface WorkflowPermissionSubset extends Pick<
  Apollo.WorkflowPermission,
  'accessLevel' | 'id' | 'isAssignee' | 'timeliness' | '__typename' | 'isExternal' | 'isLauncher'
> {
  account: AccountSubset | null;
  role: UserDefinedRoleSubset | null;
}

/** A slot filled later rather than a person: an unfilled role or the template's launcher. */
export function getIsPlaceholderPermission(permission: {
  account: Pick<AccountSubset, '__typename'> | null;
  role: Pick<UserDefinedRoleSubset, 'id'> | null;
  isLauncher?: boolean;
}): boolean {
  return Boolean(permission.isLauncher) || getIsRolePermission(permission);
}

export function getIsRolePermission(permission: {
  account: Pick<AccountSubset, '__typename'> | null;
  role: Pick<UserDefinedRoleSubset, 'id'> | null;
}): boolean {
  return Boolean(permission.role) && permission.account?.__typename !== 'User';
}
